import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import Actions from './actions';
var Types = Actions.Types;
var INITIAL_STATE = {
  isLoading: true,
  isError: false,
  categories: [],
  results: [],
  currentCategory: "",
  features: {},
  upsell: [],
  defaultOptions: ""
};

var menuReducer = function menuReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case Types.REQUEST:
      {
        //console.log('REQUEST MENU: ', action);
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: true
        });
      }

    case Types.RESPONSE:
      {
        var categories = action.categories,
            results = action.results,
            menuType = action.menuType,
            storeId = action.storeId;
        return _objectSpread(_objectSpread({}, state), {}, {
          categories: categories,
          results: results,
          menuType: menuType,
          storeId: storeId,
          isLoading: false
        });
      }

    case Types.CATEGORY_CHANGE:
      {
        var currentCategory = action.currentCategory;
        return _objectSpread(_objectSpread({}, state), {}, {
          currentCategory: currentCategory
        });
      }

    case Types.FEATURE_REQUEST:
      {
        //console.log("IN FEATURE REQUEST", state)
        return _objectSpread(_objectSpread({}, state), {}, {
          isFeatureLoading: true
        });
      }

    case Types.FEATURE_RESPONSE:
      {
        var features = action.features; //console.log("IN FEATURE RESPONSE", features, state)

        return _objectSpread(_objectSpread({}, state), {}, {
          features: features,
          isFeatureLoading: false
        });
      }

    case Types.SET_DEFAULT:
      {
        var defaultOptions = action.defaultOptions;
        return _objectSpread(_objectSpread({}, state), {}, {
          defaultOptions: defaultOptions
        });
      }

    case Types.CLEAR_MENU:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          categories: [],
          results: []
        });
      }

    case Types.REQUEST_UPSELL:
      {
        return _objectSpread({}, state);
      }

    case Types.RECEIVE_UPSELL:
      {
        var _features = action.features;
        return _objectSpread(_objectSpread({}, state), {}, {
          upsell: _features
        });
      }

    default:
      {
        return state;
      }
  }
};

export default menuReducer;